import React, { useRef, useState } from 'react';
import { Modal, Button, Row, Col, ButtonGroup, Form } from 'react-bootstrap';

import messageService from './../../Services/message';


const FileUploaderMessage = ({show, hide, callback}) =>{
    const [fileType, setFileType] = useState(0);
    
    const fileInput = useRef(null);
    const fileInputNote = useRef(null);

    const onUpload = async(e)=>{
        e.preventDefault();
        const formData = new FormData();
        const a = fileInput.current.files;

        for(const file of a)
            formData.append('file', file);
        
        const size = Object.values(a).reduce((acc, v)=>{return acc + v.size},0)
        if (size < 4e12){
            const res = await messageService.uploadFileMessage(formData);
            if(res.success) {
                let data = {}
                if(fileType)    data = {images: res.files}
                else            data = {docs: res.files}
                callback(data);
            }
            else console.log(res.err)
        }
        else fileInputNote.current.innerHTML = <p className='text-danger' >File Size exceeds in {size}B</p>
    }

    return ( 
        <Modal show={show} onHide={hide} centered >
            <Modal.Header closeButton>
                <Row>
                    <Col>
                        <i>ATTACH {fileType ? 'IMAGE' : 'DOCUMENT'}</i>
                    </Col>
                </Row>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col>
                        <ButtonGroup>
                            <Button 
                                variant = 'dark' 
                                size='sm' 
                                active={fileType === 1} 
                                onClick={()=>setFileType(0)}
                            >DOCUMENT
                            </Button>
                            <Button 
                                variant = 'dark' 
                                size='sm' 
                                active={fileType === 0} 
                                onClick={()=>setFileType(1)
                            }>IMAGE</Button>
                        </ButtonGroup>
                    </Col>
                </Row>
                <Row className='mt-3'>
                    <Col>
                        <Form >    
                            <Form.Control 
                                type='file' 
                                ref={fileInput} 
                                className='border rounded' 
                                accept ={fileType ? 'image/*' : 'application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,text/plain, application/pdf,'}
                                multiple
                                />
                        </Form>
                    </Col>
                </Row>
                <Row>
                    <Col className='text-danger font12 mt-2' ref={fileInputNote}></Col>
                </Row>
                <Row>
                    <Col className='mt-3 d-flex justify-content-end'>
                        <Button variant='light' onClick={hide}>Cancel</Button>
                        <Button className='ml-2' variant='success' type='sm' onClick={onUpload}>Send</Button>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    )
}

export default FileUploaderMessage